"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SpecialPriceController_1 = require("./SpecialPriceController");
var discountController_1 = require("./discountController");
var configuration_1 = require("../configuration");
var ListValue_1 = require("../ListValue");
var NewConditionsAdapter_1 = require("./adapters/NewConditionsAdapter");
var posterController_1 = require("./posterController");
var checkForValidFrequencyCapping_1 = require("./datalayerHelpers/checkForValidFrequencyCapping");
var UpdatedPlacementGenerator = (function () {
    function UpdatedPlacementGenerator(preset, getAllowedTargetingKeys, treeManager, posterController, ddfPeriodToMmxlPeriod, getRateCardOptions) {
        this._preset = preset;
        this._getAllowedTargetingKeys = getAllowedTargetingKeys;
        this._treeManager = treeManager;
        this._posterController = posterController;
        this._ddfPeriodToMmxlPeriod = ddfPeriodToMmxlPeriod;
        this._getRateCardOptions = getRateCardOptions;
        this.populateKeyActionPairs();
    }
    UpdatedPlacementGenerator.prototype.populateKeyActionPairs = function () {
        this._keyActionPairs = new Array();
        this._keyActionPairs.push({ key: "pi", action: this.processPi });
        this._keyActionPairs.push({ key: "share", action: this.processShare });
        this._keyActionPairs.push({ key: "frequency", action: this.processFrequency });
        this._keyActionPairs.push({ key: "medium.period", action: this.processPeriod });
        this._keyActionPairs.push({ key: "conditions", action: this.processConditions });
        this._keyActionPairs.push({ key: "conditions.online.adFormat", action: this.processAdformat });
        this._keyActionPairs.push({ key: "additionalData.frequencyCappingFormatted", action: this.processFrequencyCapping });
        this._keyActionPairs.push({ key: "additionalData.frequencyCappingForTotal", action: this.processFrequencyCappingForTotal });
        this._keyActionPairs.push({ key: "targeting.keys", action: this.processTargeting });
        this._keyActionPairs.push({ key: "specialDiscounts.type", action: this.processSpecialDiscountsType });
        this._keyActionPairs.push({ key: "conditions.gross", action: this.processGross });
        this._keyActionPairs.push({ key: "conditions", action: this.processConditions });
        this._keyActionPairs.push({ key: "additionalData.specialPriceData", action: this.processSpecialPrice });
        this._keyActionPairs.push({ key: "conditions.online.fixedPriceWithShare", action: this.processFixedPriceWithShare });
        this._keyActionPairs.push({ key: "userAnnotation", action: this.processUserAnnotation });
        this._keyActionPairs.push({ key: "specialDiscounts.amount1", action: this.processDiscounts });
        this._keyActionPairs.push({ key: "specialDiscounts.amount2", action: this.processDiscounts });
        this._keyActionPairs.push({ key: "specialDiscounts.amount3", action: this.processDiscounts });
        this._keyActionPairs.push({ key: "specialDiscounts.amount4", action: this.processDiscounts });
        this._keyActionPairs.push({ key: "specialDiscounts.amount5", action: this.processDiscounts });
        this._keyActionPairs.push({ key: "conditions.agencyCommission", action: this.processAgencyCommission });
        this._keyActionPairs.push({ key: "conditions.cashDiscount", action: this.processCashDiscount });
        this._keyActionPairs.push({ key: "conditions.vat", action: this.processVat });
        this._keyActionPairs.push({ key: "additionalData.specialDiscount", action: this.processSpecialDiscount });
        this._keyActionPairs.push({ key: "group", action: this.processGroup });
        this._keyActionPairs.push({ key: "additionalData.posterHour", action: this.processPosterHour });
        this._keyActionPairs.push({ key: "additionalData.posterWeekday", action: this.processPosterWeekDay });
        this._keyActionPairs.push({ key: "additionalData.posterSpotLength", action: this.processPosterSpotLength });
        this._keyActionPairs.push({ key: "additionalData.posterRegion", action: this.processPosterRegion });
        this._keyActionPairs.push({ key: "period", action: this.processPeriodDialog });
    };
    UpdatedPlacementGenerator.setFrequencyCappingFormatted = function (placement) {
        if (_.get(placement, "frequencyCapping.impressions")) {
            placement.additionalData.frequencyCappingFormatted = placement.frequencyCapping.impressions.toString();
        }
    };
    UpdatedPlacementGenerator.getNewFCFormValue = function (placement) {
        var fcFormatted = _.get(placement, "additionalData.frequencyCappingFormatted");
        if (fcFormatted && fcFormatted !== configuration_1.PlanConfiguration.ERROR_STRING) {
            return fcFormatted.toString();
        }
        else {
            return "";
        }
    };
    UpdatedPlacementGenerator.prototype.isPreset = function (placement) {
        return placement.medium.key === "DUMMY_MEDIUM";
    };
    UpdatedPlacementGenerator.prototype.processPi = function (placement, value) {
        placement.pi = value;
        delete placement.share;
    };
    UpdatedPlacementGenerator.prototype.processShare = function (placement, value) {
        placement.share = value;
        delete placement.pi;
    };
    UpdatedPlacementGenerator.prototype.processFrequency = function (placement, value) {
        placement.frequency = value;
        SpecialPriceController_1.SpecialPriceController.addSpecialPriceToPlacement(placement, placement.additionalData.specialPriceData);
    };
    UpdatedPlacementGenerator.prototype.processPeriod = function (placement, value) {
        var newFCFormValue = UpdatedPlacementGenerator.getNewFCFormValue(placement);
        var newFCForTotalValue = _.get(placement, "additionalData.frequencyCappingForTotal");
        placement.medium = _.assign({}, placement.medium, { period: value });
        this._placementsToDo.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, -1, false, this._getRateCardOptions()).then(function (checkResult) {
            if (checkResult === true) {
                _.set(placement, "additionalData.frequencyCappingFormatted", newFCFormValue);
                _.set(placement, "additionalData.frequencyCappingForTotal", newFCForTotalValue);
            }
            else {
                _.set(placement, "additionalData.frequencyCappingFormatted", configuration_1.PlanConfiguration.ERROR_STRING);
                _.set(placement, "additionalData.frequencyCappingForTotal", undefined);
                delete placement.frequencyCapping;
            }
        }));
    };
    UpdatedPlacementGenerator.isOnlineMedium = function (medium) {
        return (medium.tariffConditionId === "OnlineMedium" ||
            medium.tariffConditionId === "DigitalMedium" ||
            medium.tariffConditionId === "MobileMedium");
    };
    UpdatedPlacementGenerator.prototype.processConditions = function (placement, value) {
        var newFCFormValue = UpdatedPlacementGenerator.getNewFCFormValue(placement);
        var newFCForTotalValue = _.get(placement, "additionalData.frequencyCappingForTotal");
        if (UpdatedPlacementGenerator.isOnlineMedium(placement.medium)) {
            value = new ListValue_1.ListValue(value.list, "value", value.currentValue, "Keine Werbeform");
            if (placement.additionalData &&
                placement.additionalData.specialPriceData) {
                delete placement.additionalData.specialPriceData.proprietaryName;
            }
            if (!placement.conditions) {
                return;
            }
            placement.conditions =
                _.assign({}, placement.conditions, { online: _.assign({}, placement.conditions.online, { adFormat: value.current }) });
            if (!this.isPreset(placement)) {
                this._placementsToDo.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, -1, false, this._getRateCardOptions()).then(function (checkResult) {
                    if (checkResult === true) {
                        if (!placement.frequencyCapping) {
                            _.set(placement, "additionalData.frequencyCappingFormatted", newFCFormValue);
                            placement.additionalData.frequencyCappingForTotal = newFCForTotalValue;
                        }
                    }
                    else {
                        placement.additionalData.frequencyCappingFormatted = configuration_1.PlanConfiguration.ERROR_STRING;
                        placement.additionalData.frequencyCappingForTotal = undefined;
                        delete placement.frequencyCapping;
                    }
                }));
            }
        }
        else {
            var pickedValue = _.pick(value, ["online", "isPresetRow", "year"]);
            _.set(placement, "conditions", pickedValue);
        }
    };
    UpdatedPlacementGenerator.prototype.processAdformat = function (placement, value) {
        var newFCFormValue = UpdatedPlacementGenerator.getNewFCFormValue(placement);
        var newFCForTotalValue = _.get(placement, "additionalData.frequencyCappingForTotal");
        value = new ListValue_1.ListValue(value.list, "value", value.currentValue, "Keine Werbeform");
        if (placement.additionalData &&
            placement.additionalData.specialPriceData) {
            delete placement.additionalData.specialPriceData.proprietaryName;
        }
        if (!placement.conditions) {
            return;
        }
        placement.conditions =
            _.assign({}, placement.conditions, { online: _.assign({}, placement.conditions.online, { adFormat: value.current }) });
        if (!this.isPreset(placement)) {
            this._placementsToDo.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, -1, false, this._getRateCardOptions()).then(function (checkResult) {
                if (checkResult === true) {
                    if (!placement.frequencyCapping) {
                        _.set(placement, "additionalData.frequencyCappingFormatted", newFCFormValue);
                        placement.additionalData.frequencyCappingForTotal = newFCForTotalValue;
                    }
                }
                else {
                    placement.additionalData.frequencyCappingFormatted = configuration_1.PlanConfiguration.ERROR_STRING;
                    placement.additionalData.frequencyCappingForTotal = undefined;
                    delete placement.frequencyCapping;
                }
            }));
        }
    };
    UpdatedPlacementGenerator.prototype.processFrequencyCapping = function (placement, value) {
        if (value === "0") {
            delete placement.frequencyCapping;
        }
        else {
            var base_1 = 10;
            var isPreset = this.isPreset(placement);
            if ((placement.conditions &&
                placement.conditions.online &&
                placement.conditions.online.adFormat !== "AGOF_Werbeform_0") || (isPreset === true)) {
                this._placementsToDo.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, parseInt(value, base_1), isPreset, this._getRateCardOptions()).then(function (checkResult) {
                    if (checkResult !== undefined) {
                        if (checkResult === true) {
                            placement.frequencyCapping =
                                _.assign({}, placement.frequencyCapping, { impressions: parseInt(value, base_1) });
                            _.set(placement, "additionalData.frequencyCappingFormatted", value.toString());
                        }
                        else {
                            configuration_1.PlanConfiguration.logger.warn("FC out of range");
                            delete placement.frequencyCapping;
                            placement.additionalData.frequencyCappingFormatted = "";
                        }
                    }
                    else {
                        configuration_1.PlanConfiguration.logger.warn("FC not possible");
                        delete placement.frequencyCapping;
                        placement.additionalData.frequencyCappingFormatted = configuration_1.PlanConfiguration.ERROR_STRING;
                        placement.additionalData.frequencyCappingForTotal = undefined;
                    }
                }));
            }
        }
    };
    UpdatedPlacementGenerator.prototype.processFrequencyCappingForTotal = function (placement, value) {
        if (value !== undefined) {
            if (placement.frequencyCapping && placement.frequencyCapping.impressions) {
                placement.frequencyCapping =
                    _.assign({}, placement.frequencyCapping, { forTotal: !value });
                placement.additionalData.frequencyCappingForTotal = value;
            }
            else {
                if (!placement.frequencyCapping) {
                    placement.frequencyCapping = {};
                }
                placement.frequencyCapping =
                    _.assign({}, placement.frequencyCapping, { impressions: 0 });
                placement.frequencyCapping =
                    _.assign({}, placement.frequencyCapping, { forTotal: !value });
                placement.additionalData.frequencyCappingForTotal = undefined;
                var base = 10;
                this._placementsToDo.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, parseInt(value, base), this.isPreset(placement), this._getRateCardOptions())
                    .then(function (checkResult) {
                    if (checkResult !== undefined) {
                        placement.additionalData.frequencyCappingForTotal = value;
                    }
                }));
            }
        }
    };
    UpdatedPlacementGenerator.prototype.processTargeting = function (placement, value) {
        var _this = this;
        if (_.isArray(value.keys)) {
            this._placementsToDo.push(this._getAllowedTargetingKeys(placement, value.keys, this.isPreset(placement)).then(function (checkedKeys) {
                if (!value.shortCaption) {
                    value.shortCaption = _this._treeManager.getShortDescriptions(value.keys);
                }
                placement["targetingSummaryLong"] = _this._treeManager.getLongDescriptions(value.keys);
                placement.targeting = {
                    keys: checkedKeys, wastage: value.wastage, shortCaption: value.shortCaption, longCaption: value.longCaption
                };
            }));
        }
    };
    UpdatedPlacementGenerator.prototype.processSpecialDiscountsType = function (placement, value) {
        _.set(placement, "specialDiscounts.type", value);
    };
    UpdatedPlacementGenerator.prototype.processGross = function (placement, value) {
        placement.conditions.gross = value;
    };
    UpdatedPlacementGenerator.prototype.processSpecialPrice = function (placement, value) {
        SpecialPriceController_1.SpecialPriceController.addSpecialPriceToPlacement(placement, value);
    };
    UpdatedPlacementGenerator.prototype.processFixedPriceWithShare = function (placement, value) {
        placement.conditions.online.fixedPriceWithShare = value;
    };
    UpdatedPlacementGenerator.prototype.processUserAnnotation = function (placement, value) {
        placement.userAnnotation = value;
    };
    UpdatedPlacementGenerator.prototype.processDiscounts = function (placement, value, key) {
        _.set(placement, key, value);
        _.set(placement, "additionalData.specialDiscount", discountController_1.DiscountController.getSpecialDiscount(placement.specialDiscounts));
        discountController_1.DiscountController.updateSpecialDiscounts(placement.specialDiscounts, new NewConditionsAdapter_1.NewConditionsAdapter(placement.conditions));
    };
    UpdatedPlacementGenerator.prototype.processAgencyCommission = function (placement, value) {
        _.set(placement, "conditions.agencyCommission", value);
    };
    UpdatedPlacementGenerator.prototype.processCashDiscount = function (placement, value) {
        _.set(placement, "conditions.cashDiscount", value);
    };
    UpdatedPlacementGenerator.prototype.processVat = function (placement, value) {
        _.set(placement, "conditions.vat", value);
    };
    UpdatedPlacementGenerator.prototype.processSpecialDiscount = function (placement, value) {
        if (value.toString().toLowerCase() === "keinen") {
            discountController_1.DiscountController.setDiscountsToZero(placement.specialDiscounts);
            placement.additionalData.specialDiscount = value;
        }
    };
    UpdatedPlacementGenerator.prototype.processGroup = function (placement, value) {
        placement.group = value.toString();
    };
    UpdatedPlacementGenerator.prototype.processPosterData = function (placement, value, key, additionalDataKey) {
        this.setPosterMediumKey(placement, key, key, value);
        delete this._preset.additionalData[additionalDataKey];
    };
    UpdatedPlacementGenerator.prototype.processPosterHour = function (placement, value) {
        this.processPosterData(placement, value, "hour", "posterHour");
    };
    UpdatedPlacementGenerator.prototype.processPosterWeekDay = function (placement, value) {
        this.processPosterData(placement, value, "weekday", "posterWeekDay");
    };
    UpdatedPlacementGenerator.prototype.processPosterSpotLength = function (placement, value) {
        this.processPosterData(placement, value, "spotlength", "posterSpotLength");
    };
    UpdatedPlacementGenerator.prototype.processPosterRegion = function (placement, value) {
        this.processPosterData(placement, value, "region", "posterRegion");
    };
    UpdatedPlacementGenerator.prototype.processPeriodDialog = function (placement, value) {
        var storagePeriod = this._ddfPeriodToMmxlPeriod(value);
        _.set(placement, "dates", storagePeriod.dates);
        _.set(placement, "period", storagePeriod.store);
        _.set(placement, "medium.period", storagePeriod.average);
        var newFCFormValue = UpdatedPlacementGenerator.getNewFCFormValue(placement);
        var newFCForTotalValue = _.get(placement, "additionalData.frequencyCappingForTotal");
        this._placementsToDo.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, -1, false, this._getRateCardOptions()).then(function (checkResult) {
            if (checkResult === true) {
                _.set(placement, "additionalData.frequencyCappingFormatted", newFCFormValue);
                _.set(placement, "additionalData.frequencyCappingForTotal", newFCForTotalValue);
            }
            else {
                _.set(placement, "additionalData.frequencyCappingFormatted", configuration_1.PlanConfiguration.ERROR_STRING);
                _.set(placement, "additionalData.frequencyCappingForTotal", undefined);
                delete placement.frequencyCapping;
            }
        }));
    };
    UpdatedPlacementGenerator.setFixedPriceWithShare = function (placement) {
        if (placement.share === 1 || _.get(placement, "conditions.online.fixedPriceWithShare") === true) {
            _.set(placement, "conditions.online.pricing", "TryFixPrice");
        }
        else {
        }
    };
    UpdatedPlacementGenerator.prototype.getUpdatedPlacement = function (placement, field, value) {
        var newPlacement = _.assign({}, placement);
        discountController_1.DiscountController.setEmptyAdditionalData(newPlacement);
        UpdatedPlacementGenerator.setFrequencyCappingFormatted(newPlacement);
        this._placementsToDo = [];
        var actionToDo = _.find(this._keyActionPairs, function (candidate) {
            return field === candidate.key;
        });
        if (actionToDo) {
            actionToDo.action.call(this, newPlacement, value, field);
        }
        else {
            configuration_1.PlanConfiguration.logger.warn("Warning: change of field " + field + " ignored");
        }
        UpdatedPlacementGenerator.setFixedPriceWithShare(newPlacement);
        return Promise.all(this._placementsToDo).then(function () {
            return newPlacement;
        });
    };
    UpdatedPlacementGenerator.prototype.setPosterMediumKey = function (placement, path, key, value) {
        var oldKey = placement.medium.key;
        if (oldKey !== "DUMMY_MEDIUM") {
            var type = posterController_1.PosterController.getComponentsFromMediumKey(oldKey).type;
            var index = this._posterController.getIndexFromTitle(type, key, value);
            var newKey = posterController_1.PosterController.generateNewMediumKey(oldKey, key, index);
            _.set(placement, "medium.key", newKey);
            _.set(placement, "medium.longTitle", this._posterController.getProductTitleByKey(type));
        }
        _.set(placement, path, value);
    };
    return UpdatedPlacementGenerator;
}());
exports.UpdatedPlacementGenerator = UpdatedPlacementGenerator;
//# sourceMappingURL=UpdatedPlacementGenerator.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/UpdatedPlacementGenerator.js
// module id = 71
// module chunks = 0